module.exports = __webpack_public_path__ + "img/route_9.5e8ae166.svg";